<template>
  <div class="container-fluid mt-3 details-reports__partner">
    <div>
      <div class="card px-2 py-3 container-fluid">
        <!--     init Comisiones y retiros  -->
        <div class="row px-0 justify-content-orientation">
          <div
            class="col-sm-12 col-md-6 col-lg-4 col-lg-mobile d-flex py-5 flex-column align-items-center payout-donut"
          >
            <div class="d-flex flex-column mt-render py-2 align-items-center">
              <i class="fa fa-lock iconLock"></i>
              <p class="m-0">COMISIONES DISPONIBLES</p>
              <p class="h3">${{ getPartnerOrders.total }}</p>
            </div>
          </div>

          <!-- Status Comision details -->

          <div
            class="col-sm-12 container-mobile-reports col-md-12 col-lg-4 col-lg-mobile d-flex flex-column mt-0 rounded px-4 padding-top__container-center"
            v-if="getPartnerOrders.total > 1"
          >
            <p class="h2">¡Estás en camino de que te paguen!</p>
            <p>
              Su próximo pago de recompensas estará disponible para retiro el
              <span class="font-weight-bolder">13 de diciembre de 2020.</span>
            </p>
            <div class="">
              <p class="text-uppercase font-weight-bolder m-0">
                Resumen de pago
              </p>
              <div class="d-flex justify-content-between pt-1">
                <span class="m-0">Pago estimado</span>
                <span>${{ getPartnerOrders.total }}</span>
              </div>
              <div class="d-flex justify-content-between pt-1 pb-2">
                <span>Tarifa de procesamiento {{ type }} *</span>
                <span>-$0</span>
              </div>
              <hr class="p-0 m-0" />
              <div
                class="d-flex justify-content-between font-weight-bolder pt-1"
              >
                <span class="h3">Total</span>
                <span class="h3">${{ getPartnerOrders.total }} USD</span>
              </div>
            </div>
          </div>
          <div
            class="col d-flex flex-column align-items-center justify-content-center rounded container-mobile-reports p-3"
            v-else
          >
            <p class="h3">
              <i class="fa fa-times-circle"></i> No tienes ningúna comisión
              disponible
            </p>
            <p>
              Todas las próximas recompensas y retiros disponibles se mostrarán
              aquí.
            </p>
          </div>
          <!-- End Status Comision details -->

          <!-- Init Payment Method Details || payment method -->
          <!-- <div
            class="col bg-lighter rounded p-3 text-primary d-flex flex-column justify-content-center container-mobile-reports"
            v-if="!paymentMethod"
            >
            <div class="row">
              <div class="col-2 py-3 px-4">
                <i class="fa fa-exclamation-circle iconTimes"></i>
              </div>
              <div class="col">
                <p class="h2">No has conectado un proveedor de pagos</p>
              </div>
            </div>
            <p class="">
              Para retirar sus fondos, primero debe vincularse a su cuenta de
              <b class="font-weight-bolder">Stripe</b> o
              <b class="font-weight-bolder">PayPal</b>.
            </p>
            <button
              class="btn btn-maquillate mx-auto py-2"
              @click="showDialogPay = true"
            >
              Agregar un proveedor de pagos
            </button>
          </div> -->
          <div
            v-if="!paymentMethod"
            class="col-sm-12 col-md-12 col-lg-4 col-lg-mobile p-0 text-primary padding-top__container-end container-mobile-reports"
          >
            <p class="h2 text-center">Detalles del proveedor de pago</p>
            <div class="bg-lighter p-3 rounded">
              <div class="text-center">
                <p class="h3">
                  <i
                    class="fa fa-exclamation-circle iconTimes"
                    style="font-size: 17px; margin-right: 10px"
                  ></i
                  >No has conectado un proveedor de pagos
                </p>
                <hr class="my-3" />
                <p class="my-3" style="font-size: 14px">
                  Para retirar sus fondos, primero debe vincularse a su cuenta
                  de
                  <b class="font-weight-bolder">Stripe</b> o
                  <b class="font-weight-bolder">PayPal</b>.
                </p>
                <button
                  class="btn btn-maquillate mx-auto py-2"
                  @click="showDialogPay = true"
                >
                  Agregar un proveedor de pagos
                </button>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-4 col-lg-mobile p-0 text-primary padding-top__container-end container-mobile-reports"
            v-if="paymentMethod"
          >
            <p class="h2 text-center">Detalles del proveedor de pago</p>
            <div class="bg-lighter p-3 rounded">
              <div class="text-center">
                <p class="h3">
                  Estas conectado con <span>{{ type }}</span>
                </p>
                <span>{{ data.email ? data.email : '' }}</span>
                <hr class="my-3" />
                <p class="my-3">
                  * {{ type }} cobra 2% hasta un máximo de $20.00 USD
                </p>

                <button
                  class="btn btn-primary btn-maquillate p-2 mb-2"
                  @click="modals.updateMethodModal = true"
                >
                  Actualizar el metodo
                </button>
                <button
                  class="btn btn-primary btn-maquillate p-2 mb-2"
                  @click="showDialogPayPalDefault = true"
                  v-if="type == 'Paypal'"
                >
                  Detalles
                </button>
              </div>
            </div>
          </div>
          <!--END Payment Method Details || payment method -->
        </div>
      </div>
      <!--END Comisiones y retiros  -->
      <!--INIT Comisiones y retiros TABS-->
      <div class="card p-3">
        <vue-tabs class="sections-payment">
          <!--INIT Comisiones -->
          <v-tab title="Comisiones" class="padding-commissions">
            <md-table class="px-0">
              <md-table-row class="container-instructors__head table-striped">
                <md-table-head>Creado</md-table-head>
                <md-table-head>Curso</md-table-head>
                <md-table-head>Fuente</md-table-head>
                <md-table-head>Estado de retiro</md-table-head>
                <!-- <md-table-head>Estado del pago</md-table-head> -->
                <md-table-head>Dia de pago</md-table-head>
                <md-table-head>Monto</md-table-head>
              </md-table-row>
              <!--     Data table -->
              <md-table-row
                class="container-instructors__cell"
                v-for="order in getPartnerOrders.orders"
                :key="order.id"
              >
                <md-table-cell>
                  <div class="d-flex align-items-center">
                    <p class="p-0 m-0 font-weight-bolder">
                      {{ getDateFormat(order.created_at) }}
                    </p>
                  </div>
                </md-table-cell>
                <md-table-cell>
                  <div class="d-flex align-items-center">
                    <p class="p-0 m-0 font-weight-bolder">
                      {{ order.course.name }}
                    </p>
                  </div>
                </md-table-cell>
                <md-table-cell>
                  <div
                    class="d-flex flex-column align-items-start justify-content-start"
                  >
                    <p class="p-0 m-0 font-weight-bolder">
                      {{ order.user.name }}
                    </p>
                    <span class="p-0 font-weight-normal">{{
                      order.user.email
                    }}</span>
                  </div>
                </md-table-cell>

                <md-table-cell>
                  <div class="d-flex align-items-center">
                    <span
                      class="bagde-pending"
                      v-if="order.statusPartner == 'pending'"
                    >
                      Pendiente
                    </span>

                    <span
                      class="bagde-complete"
                      v-if="order.statusPartner == 'complete'"
                    >
                      Completado
                    </span>
                  </div>
                </md-table-cell>
                <!-- <md-table-cell>
                  <div
                    class="
                      d-flex
                      flex-column
                      align-items-center
                      justify-content-center
                    "
                  >
                    <p>Pendiente por aprobar</p>
                  </div>
                </md-table-cell> -->
                <md-table-cell>
                  <div
                    class="d-flex flex-column align-items-start justify-content-start"
                  >
                    <p class="p-0 m-0 font-weight-bolder">Dec 13, 2020</p>
                    <span class="p-0 font-weight-normal">Tiempo estimado </span>
                  </div>
                </md-table-cell>
                <md-table-cell>
                  <div class="d-flex align-items-left justify-content-left">
                    <span>${{ order.totalPartner }}</span>
                  </div>
                </md-table-cell>
              </md-table-row>
              <!--   END  Data table -->
            </md-table>
          </v-tab>
          <!--INIT Retiros Table-->
          <v-tab title="Retiros" class="padding-withdrawals">
            <md-table class="px-0">
              <md-table-row class="container-instructors__head">
                <md-table-head>Fecha de retiro</md-table-head>
                <md-table-head>Método de pago</md-table-head>
                <md-table-head>Estado</md-table-head>
                <md-table-head>Monto(USD)</md-table-head>
                <!-- <md-table-head>Recompensas de Comisiones</md-table-head> -->
              </md-table-row>
              <!--     Data table -->
              <md-table-row
                class="container-instructors__cell"
                v-for="payment in getPaymentsByPartner"
                :key="payment.id"
              >
                <md-table-cell>
                  <div class="d-flex align-items-center">
                    <p class="p-0 m-0 font-weight-bolder">
                      {{ getDateFormat(payment.updated_at) }}
                    </p>
                  </div>
                </md-table-cell>
                <md-table-cell>
                  <div
                    class="d-flex align-items-center"
                    style="font-size: 16px"
                  >
                    {{ payment.payment_method }}
                  </div>
                </md-table-cell>

                <md-table-cell>
                  <div class="d-flex align-items-center">
                    <span
                      class="bagde-pending"
                      v-if="payment.status == 'pending'"
                    >
                      Pendiente
                    </span>

                    <span
                      class="bagde-complete"
                      v-if="payment.status == 'complete'"
                    >
                      Completado
                    </span>
                  </div>
                </md-table-cell>
                <md-table-cell>
                  <div class="d-flex align-items-center">
                    <p class="p-0 m-0 font-weight-bolder">
                      ${{ payment.amount }}
                    </p>
                  </div>
                </md-table-cell>
              </md-table-row>
              <!--   END  Data table -->
            </md-table>
          </v-tab>
        </vue-tabs>
      </div>
    </div>
    <!--  methods payment -->

    <!-- payment first -->
    <md-dialog :md-active.sync="showDialogPay" class="modal-close">
      <span
        class="material-icons close text-right"
        @click="showDialogPay = false"
        >close</span
      >
      <div class="body-modal-course">
        <md-dialog-title class="padding-x-none"
          >PROVEEDOR DE PAGO</md-dialog-title
        >

        <md-dialog-content class="mt-2">
          <div class="py-3 d-flex justify-content-center mobile-buttons-pay">
            <base-button
              class="btn-maquillate pay-button"
              @click="stripeConnect"
            >
              <img
                class="icon-img-pay"
                :src="require(`@/assets/images/logo/stripe_logo.svg`)"
                alt="stripe"
              />
            </base-button>
            <base-button
              class="btn-maquillate pay-button"
              @click="showDialogPayPal = true"
            >
              <img
                class="icon-img-pay"
                :src="require(`@/assets/images/logo/Paypal.svg`)"
                alt="paypal"
              />
            </base-button>
          </div>
        </md-dialog-content>

        <md-dialog-content>
          <p>
            Nota: Si está retirando más de $ 130 dólares cada mes, Stripe será
            más rentable y su efectivo se depositará directamente en su cuenta
            bancaria.
          </p>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button
            class="md-button md-primary md-theme-default"
            @click="showDialogPay = false"
            style="display: none"
            >CANCELAR</md-button
          >
          <md-button
            class="md-button md-primary md-theme-default"
            @click="showDialogPay = false"
            >CANCELAR</md-button
          >
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="showDialogPayPal" class="modal-close">
      <span
        class="material-icons close text-right"
        @click="showDialogPayPal = false"
        >close</span
      >
      <div class="body-modal-course">
        <md-dialog-title class="padding-x-none">PAYPAL</md-dialog-title>
        <md-dialog-content class="mt-2">
          <span>
            Para registrar como proveedor de pago es necesario usar tu correo de
            paypal.</span
          ></md-dialog-content
        >

        <md-dialog-content>
          <md-field>
            <div class="md-field md-theme-default md-has-placeholder pt-0">
              <md-input
                type="Email"
                placeholder="CorreoPayapal@example.com"
                v-model="dataPaypal.email"
              ></md-input>
            </div>
          </md-field>
        </md-dialog-content>

        <md-dialog-content>
          <p>
            Nota: Al proporciar tu correo de paypal podremos conectar con tu
            cuenta de manera que podamos realizar pagos seguros y fiables.
          </p>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button
            class="md-button md-primary md-theme-default"
            @click="showDialogPayPal = false"
            >CANCELAR</md-button
          >
          <md-button
            class="md-button md-primary md-theme-default"
            @click="paypalPartnerPayout"
            >CONECTAR</md-button
          >
        </md-dialog-actions>
      </div>
    </md-dialog>
    <md-dialog :md-active.sync="showDialogPayPalDefault" class="modal-close">
      <span
        class="material-icons close text-right"
        @click="showDialogPayPalDefault = false"
        >close</span
      >
      <div class="body-modal-course">
        <md-dialog-title class="padding-x-none"
          >PROVEEDOR POR DEFAULT</md-dialog-title
        >
        <md-dialog-content class="mt-2">
          <span>
            Desde este modal podras ver y cambiar tu cuenta Paypal usado como
            proveedor de pagos.</span
          ></md-dialog-content
        >

        <md-dialog-content>
          <md-field>
            <div class="md-field md-theme-default md-has-placeholder pt-0">
              <md-input
                type="Email"
                v-model="dataPaypal.emailUpdate"
                placeholder="CorreoPayapal@example.com"
              ></md-input>
            </div>
          </md-field>
        </md-dialog-content>

        <md-dialog-content>
          <p>
            Nota: Al proporciar tu correo de paypal podremos conectar con tu
            cuenta de manera que podamos realizar pagos seguros y fiables.
          </p>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button
            class="md-button md-primary md-theme-default"
            @click="showDialogPayPalDefault = false"
            >CANCELAR</md-button
          >
          <md-button
            class="md-button md-primary md-theme-default"
            @click="paypalPartnerUpdate"
            >ACTUALIZAR</md-button
          >
        </md-dialog-actions>
      </div>
    </md-dialog>
    <!-- detalle paypal email -->
    <!-- <modal :show.sync="modals.modalPaypalDetails" @close="handleClear">
      <div>
        <p class="h2 text-center">Desde este modal podras ver y cambiar tu cuenta Paypal usado como proveedor de pagos</p>
        <p class="text-success text-bold text-center">Proveedor por default</p>
        <div class=" py-3 d-flex justify-content-center">
          <div class="col-12">
            <base-input type="email" v-model="dataPaypal.emailUpdate"
              placeholder="CorreoPayapal@example.com">
            </base-input>
          </div>
        </div>
        <div class="col-12 justify-content-center text-center">
            <base-button type="primary" @click="paypalPartnerUpdate">
              <i class="ni ni-credit-card"></i> Actualizar
            </base-button>
          </div>
          <br>
        <p>
          Nota: Al proporciar tu correo de paypal podremos conectar con tu cuenta de manera que podamos realizar pagos seguros y fiables.
        </p>
      </div>

      <button class="btn btn-secondary" @click="handleClear">Cancelar</button>
    </modal> -->
    <!-- Update payment -->
    <modal :show.sync="modals.updateMethodModal" @close="handleClear">
      <div>test2</div>

      <button class="btn btn-secondary" @click="handleClear">Cancelar</button>
    </modal>
    <!-- END methods payment -->
  </div>
</template>

<script>
import { VueTabs, VTab } from 'vue-nav-tabs';
import 'vue-nav-tabs/themes/vue-tabs.css';
import Modal from '../../../components/Modal.vue';
import axios from 'axios';
import config from '@/config/config';
import moment from 'moment-timezone';
import { mapGetters } from 'vuex';
import { PARTNER_GET_BY_PARTNER } from '@/store/actions/partner';
import { GET_PAYMENTS_BY_PARTNER } from '@/store/actions/payment';

export default {
  components: {
    VueTabs,
    VTab,
    Modal,
  },
  data() {
    return {
      showDialogPay: false,
      showDialogPayPal: false,
      showDialogPayPalDefault: false,
      bool: false,
      paymentMethod: false,
      modals: {
        paymentMethodModal: false,
        modalPaypalMethod: false,
        modalPaypalDetails: false,
        updateMethodModal: false,
      },
      data: {},
      type: '',
      orders: [],
      total: 0,
      dataPaypal: {
        email: null,
        emailUpdate: null,
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      await this.$store.dispatch(PARTNER_GET_BY_PARTNER);
      await this.$store.dispatch(GET_PAYMENTS_BY_PARTNER);
    },
    handleClear() {
      this.modals.paymentMethodModal = false;
      this.modals.modalPaypalMethod = false;
      this.modals.updateMethodModal = false;
      this.modals.modalPaypalDetails = false;
    },
    getDateFormat(date) {
      // return moment.tz(date, "America/New_York").fromNow();
      return moment(date).format('ll');
    },
    async stripeConnect() {
      await axios
        .get(config.data.apiUrl + '/partner/stripe/connect', {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('user-token'), //the token is a variable which holds the token
          },
        })
        .then((resp) => {
          return window.open(resp.data.url, '_blank');
        });
    },
    async paypalPartnerPayout() {
      await axios
        .post(
          config.data.apiUrl + '/partner/paypal/payoutRegister',
          {
            data: this.dataPaypal,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('user-token'), //the token is a variable which holds the token
            },
          },
        )
        .then((resp) => {
          this.$notify({
            type: 'success',
            verticalAlign: 'top',
            horizontalAlign: 'right',
            message: resp.data,
          });
          this.handleClear();
          this.load();
          location.reload();
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 400) {
              this.$notify({
                type: 'danger',
                verticalAlign: 'top',
                horizontalAlign: 'right',
                message: err.response.data,
              });
            }
          }
        });
    },
    async paypalPartnerUpdate() {
      await axios
        .post(
          config.data.apiUrl + '/partner/paypal/payoutUpdate',
          {
            data: this.dataPaypal.emailUpdate,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('user-token'),
            },
          },
        )
        .then((resp) => {
          this.$notify({
            type: 'success',
            verticalAlign: 'top',
            horizontalAlign: 'right',
            message: 'Cuenta de proveedor paypal actualizada con éxito',
          });
          this.handleClear();
          this.load();
          location.reload();
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 400) {
              this.$notify({
                type: 'danger',
                verticalAlign: 'top',
                horizontalAlign: 'right',
                message: err.response.data,
              });
            }
          }
        });
    },
  },
  async beforeMount() {
    await axios
      .get(config.data.apiUrl + '/partner/stripe/verify', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('user-token'),
        },
      })
      .then(({ data }) => {
        console.log(data);
        if (data === 'invalido') {
          this.paymentMethod = false;
        } else {
          this.data = data;
          this.paymentMethod = true;
          this.type = data.name;
          this.dataPaypal.emailUpdate = data.address;
        }
      });
    /* await axios
      .get(config.data.apiUrl + "/partner/classes/getByPartner", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("user-token"), //the token is a variable which holds the token
        },
      })
      .then(({ data }) => {
        this.orders = data.orders;
        this.total = data.total;
        if (data.total != 0) {
          this.bool = true;
        }
        //console.log(data)
      }); */
  },
  computed: {
    ...mapGetters(['getPartnerOrders', 'getPaymentsByPartner']),
  },
};
</script>

<style>
.iconTimes {
  font-size: 2em;
}
.payout-donut {
  background: url('/payout-donut-disabled.6d7e13c4.svg');
  background-repeat: no-repeat;
  background-position: 50%;
  width: 271px;
  height: 271px;
}
.iconLock {
  font-size: 2em;
}
</style>
